import angular from 'angular';
import ImageModalModule from './image-modal/image-modal';

const ComponentsModule = angular.module('control-room.commons.content.components.image-uploader.components', [
    ImageModalModule.name,
]);

export default ComponentsModule;
